import {Component, Directive, Module} from 'app/decorators';
import ProductStore from 'app/stores/product';

import BasePicker from './base.picker';


@Module({
    name: "app.directives.read_only_icon",
})
@Directive('read-only-as400', function () {
    "ngInject"
    return {
        restrict: 'A',
        template: `
        <i class="fa fa-question-circle" aria-hidden="true" uib-tooltip="Field synced from AS400"></i>
        `
    };
})
export default class D {
    constructor () {
        "ngInject";
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/read_only_icon.js